import { ApplicationState } from '../../../../store/types';
import { getSearchDocumentsRoot } from '../../store/selectors';
import { SearchDocumentsView, SearchFilter, SearchResult, SmartSearch } from './types';

export const getSearchFilterModalOpen = (state: ApplicationState): boolean => getSearchDocumentsRoot(state).filterModalOpen;

export const getSearchFilters = (state: ApplicationState): SearchFilter => getSearchDocumentsRoot(state).searchFilter;

export const getSearchDocumentsView = (state: ApplicationState): SearchDocumentsView => getSearchDocumentsRoot(state).searchDocumentsView;

export const getSimpleSearchTerm = (state: ApplicationState): string => getSearchDocumentsRoot(state).simpleSearchTerm;

export const getSmartSearchTerm = (state: ApplicationState): SmartSearch[] => getSearchDocumentsRoot(state).smartSearchTerm;

export const getIsSearching = (state: ApplicationState): boolean => getSearchDocumentsRoot(state).isSearching;

export const getSearchResults = (state: ApplicationState): SearchResult[] | null => getSearchDocumentsRoot(state).searchResults;

export const getTotalSearchResults = (state: ApplicationState): number => getSearchDocumentsRoot(state).totalSearchResults;

export const getSearchResultPage = (state: ApplicationState): number => getSearchDocumentsRoot(state).searchPage;

export const getResultsType = (state: ApplicationState): SearchDocumentsView | null => getSearchDocumentsRoot(state).searchResultsType;

export const getTotalPages = (state: ApplicationState): number => getSearchDocumentsRoot(state).totalSearchPages;

export const getIsOpening = (state: ApplicationState): boolean => getSearchDocumentsRoot(state).isOpening;

export const getDocumentPreviewModalOpen = (state: ApplicationState): boolean => getSearchDocumentsRoot(state).documentPreviewModalOpen;

export const getDocumentPreviewUrl = (state: ApplicationState): string | null => getSearchDocumentsRoot(state).documentPreviewUrl;

export const getDocumentPreviewResult = (state: ApplicationState): SearchResult | null => getSearchDocumentsRoot(state).documentPreviewResult;
